import React from 'react';

import CoachCareer from './CoachCareer';

const CoachPersonalInfo = ({ coach }) => {
  return (
    <div className="space-y-8">
      {/* Trophies Section */}
      <div>
        <h2 className="text-[#222A35] text-base font-bold mb-4">Trophies</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {coach.trophies?.length > 0 ? (
            coach.trophies.map((trophy) => (
              <div key={trophy.id} className="bg-[#F8F9FB] p-5 rounded-xl">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <img
                      src={trophy.tournament_image}
                      alt=""
                      className="w-15 h-15 object-cover rounded-lg"
                    />
                  </div>
                  <div className="flex flex-col">
                    <h3 className="text-[#000000] text-base font-bold">
                      {trophy.league_name}
                    </h3>
                    <p className="text-[#000000] text-sm font-medium">
                      {trophy.club_name}
                    </p>
                    <p className="text-[#3C404B] text-sm">
                      {trophy.years}
                    </p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full bg-[#F8F9FB] p-8 rounded-xl text-center">
              <p className="text-[#646B7E] text-sm">No trophies information available</p>
            </div>
          )}
        </div>
      </div>

      {/* Experience Section — the merged coaching CV (own entries + the
          TheSports resume stations, own entries win). Lives here per Marins
          final call 2026-08-21: everything stays in Personal Info, no
          separate Career tab. */}
      <CoachCareer coach={coach} />

      {/* Licenses Section */}
      <div>
        <h2 className="text-[#222A35] text-base font-bold mb-4">Licenses</h2>
        <div className="flex flex-wrap gap-3">
          {coach.licenses?.length > 0 ? (
            coach.licenses.map((license, index) => (
              <div
                key={index}
                className="px-4 py-2 rounded-full"
                style={{
                  background: 'linear-gradient(90deg, rgba(126, 139, 255, 0.2) 0%, rgba(34, 131, 255, 0.2) 100%)'
                }}
              >
                <span className="text-[#374DF5] text-base">
                  {license}
                </span>
              </div>
            ))
          ) : (
            <div className="w-full bg-[#F8F9FB] py-4 rounded-lg text-center">
              <p className="text-[#646B7E] text-sm">No licenses information available</p>
            </div>
          )}
        </div>
      </div>

      {/* Languages Section */}
      <div>
        <h2 className="text-[#222A35] text-base font-bold mb-4">Languages Known</h2>
        <div className="w-full bg-[#F8F9FB] py-4 rounded-lg">
          <div className="flex items-center gap-4">
            {coach.languages?.length > 0 ? (
              coach.languages.map((language, index) => (
                <span key={index} className="text-[#43526E] text-sm">
                  {language}
                </span>
              ))
            ) : (
              <span className="text-[#646B7E] text-sm">No languages information available</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachPersonalInfo;